import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  deviceDetailsIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    marginLeft: 0,
  },
  spinner: {
    color: theme.palette.grey[600],
    padding: 0,
    margin: 0,
    marginRight: theme.spacing(0.25),
    marginLeft: theme.spacing(0.25),
  },
}));

export default useStyles;
